<nav
    class="navbar navbar-expand-lg navbar-light bg-light"
    [class.active]="classApplied"
    [ngClass]="{'sticky': isSticky || isSolidNavbar || isPastHero}"
>
    <div class="container">
        <a class="navbar-brand" routerLink="/"><span>c</span>idhum</a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item"><a class="nav-link" (click)="onClick('home')" role="button" tabindex="0">Inicio</a></li>
                <li class="nav-item nav-dropdown" [class.open]="openDropdown === 'cidhum'">
                    <button class="nav-link dropdown-toggle" type="button" (click)="toggleDropdown('cidhum')" [attr.aria-expanded]="openDropdown === 'cidhum'">Cidhum</button>
                    <ul class="submenu">
                        <li><a (click)="navigateTo('about')" role="button">Sobre Cidhum</a></li>
                        <li><a (click)="navigateTo('team')" role="button">Equipo</a></li>
                        <li><a routerLink="/red" (click)="closeDropdown()">Red</a></li>
                    </ul>
                </li>
                <li class="nav-item nav-dropdown" [class.open]="openDropdown === 'research'">
                    <button class="nav-link dropdown-toggle" type="button" (click)="toggleDropdown('research')" [attr.aria-expanded]="openDropdown === 'research'">Investigación</button>
                    <ul class="submenu">
                        <li><a (click)="navigateTo('services')" role="button">Servicios</a></li>
                        <li><a (click)="navigateTo('work')" role="button">Nuestro trabajo</a></li>
                        <li><a (click)="navigateTo('blog')" role="button">Noticias</a></li>
                    </ul>
                </li>
                <li class="nav-item contact-item"><a class="nav-link contact-link" (click)="onClick('contact')" role="button" tabindex="0">Contáctanos</a></li>
            </ul>
            <ul class="navbar-nav ml-auto for-responsive">
                <li class="nav-item"><a class="nav-link" (click)="toggleClass(); onClick('home')" role="button" tabindex="0">Inicio</a></li>
                <li class="nav-item nav-dropdown" [class.open]="openDropdown === 'cidhum'">
                    <button class="nav-link dropdown-toggle" type="button" (click)="toggleDropdown('cidhum')">Cidhum</button>
                    <ul class="submenu">
                        <li><a (click)="navigateTo('about', true)" role="button">Sobre Cidhum</a></li>
                        <li><a (click)="navigateTo('team', true)" role="button">Equipo</a></li>
                        <li><a routerLink="/red" (click)="closeMobileNavigation()">Red</a></li>
                    </ul>
                </li>
                <li class="nav-item nav-dropdown" [class.open]="openDropdown === 'research'">
                    <button class="nav-link dropdown-toggle" type="button" (click)="toggleDropdown('research')">Investigación</button>
                    <ul class="submenu">
                        <li><a (click)="navigateTo('services', true)" role="button">Servicios</a></li>
                        <li><a (click)="navigateTo('work', true)" role="button">Nuestro trabajo</a></li>
                        <li><a (click)="navigateTo('blog', true)" role="button">Noticias</a></li>
                    </ul>
                </li>
                <li class="nav-item contact-item"><a class="nav-link contact-link" (click)="navigateTo('contact', true)" role="button" tabindex="0">Contáctanos</a></li>
            </ul>
        </div>
    </div>
</nav>
